import { MdOutlineHandshake } from 'react-icons/md';

const deals = {
  id: 'deals',
  title: '',
  type: 'group',
  children: [
    {
      id: 'deals-list',
      title: 'Deals',
      type: 'item',
      url: '/deals',
      icon: MdOutlineHandshake,
      allowedRoles: ['admin', 'superAdmin', 'financeManager', 'complianceOfficer', 'supportAgent'],
      breadcrumbs: false
    }
  ]
};

export default deals;
